import { createAsyncThunk } from '@reduxjs/toolkit';
import locationApi from '~/apis/location';
import sensorApi from '~/apis/sensor';
import { GET_PROVINCES, GET_SENSOR_TYPES } from '~/utils/constants/actionType';
import { IProvince } from '~/utils/interface/location';
import { ISensorType } from '~/utils/interface/sensor';

export const handleGetListProvinces = createAsyncThunk<IProvince[]>(GET_PROVINCES, async (_, { rejectWithValue }) => {
  try {
    const res = await locationApi.getListProvinces();

    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleGetSensorTypes = createAsyncThunk<ISensorType[]>(
  GET_SENSOR_TYPES,
  async (_, { rejectWithValue }) => {
    try {
      const res = await sensorApi.getSensorTypes();

      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
